import { fetchCollection } from '@api/editorialLayout/collectionAdmin';
import { CollectionType } from '@enums/CollectionType';
import useLoad, { DataTransformer, LoadOptions } from '@hooks/useLoad';
import Collection from '@models/Collection';
import { initializeCollectionFilters, removeEmptyParams } from '@utils/filterUtils';

export const transformCollection = (collection?: Collection) =>
  collection
    ? collection.type === CollectionType.QUERY
      ? {
          ...collection,
          ...(collection.data
            ? {
                data: {
                  ...removeEmptyParams(collection.data),
                  filter: initializeCollectionFilters(collection.data.filter),
                  queryText: collection.data.queryText || '',
                },
              }
            : {}),
        }
      : collection
    : undefined;

const getCollectionQueryKey = (id: string, queryId?: string, isTicker?: boolean) => [
  'collection',
  id,
  ...(queryId ? [queryId] : []),
  ...(isTicker ? ['ticker'] : []),
];

export const useCollectionQuery = (id: string, options?: LoadOptions, queryId?: string) =>
  useLoad(() => fetchCollection(id), getCollectionQueryKey(id, queryId, options?.isTicker), {
    ...(options as object),
    dataTransformer: transformCollection as DataTransformer<Collection>,
    enabled: !!id && options?.enabled !== false,
    refetchOnCountryChange: false,
    refetchOnDisableCache: false,
    refetchOnMount: 'always',
    refetchOnSearchLanguageChange: false,
  });
